interface routesModel {
  name: string;
  location: string[];
}

const routes: routesModel[] = [
  {
    name: 'firm',
    location: ['/firm', '/firm/register', '/firm/edit'],
  },
  {
    name: 'user',
    location: ['/user', '/user/register', '/user/edit'],
  },
  {
    name: 'employee',
    location: ['/employee', '/employee/register', '/employee/edit', '/employee/view'],
  },
  {
    name: 'employeesafety',
    location: ['/employeesafety', '/employeesafety/register', '/employeesafety/edit', '/employeesafety/view'],
  },
  {
    name: 'timesheet',
    location: ['/timesheet'],
  },
  {
    name: 'employeesalary',
    location: ['/employeesalary'],
  },
  {
    name: 'employeeadvance',
    location: ['/employeeadvance', '/employeeadvance/register', '/employeeadvance/edit'],
  },
  {
    name: 'employeesalaryreport',
    location: ['/employeesalaryreport'],
  },
  {
    name: 'employeesafetyreport',
    location: ['/employeesafetyreport'],
  },
  {
    name: 'employeeadvancereport',
    location: ['/employeeadvancereport'],
  },
  {
    name: 'employeeattendencereport',
    location: ['/employeeattendencereport'],
  },
  {
    name: 'fileroom',
    location: ['/fileroom'],
  },
];

const Exclusionroutes = ['/', '/profile', '/profile/personal-info', '/profile/security-settings'];

export const isLocationProtected = (location: string, allowedLocation: string[] | undefined): boolean => {
  //get parent name from location
  if (Exclusionroutes.indexOf(location) > -1) {
    return true;
  }
  return routes.filter((x) => x.location.indexOf(location) > -1).some(({ name }) => allowedLocation?.includes(name));
};
